import { render, staticRenderFns } from "./RendererStats.vue?vue&type=template&id=69e7a65c&lang=pug&"
import script from "./RendererStats.vue?vue&type=script&lang=js&"
export * from "./RendererStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports